// extracted by mini-css-extract-plugin
module.exports = {"container":"space_container__77Tw2","vertical":"space_vertical__mduj8","horizontal":"space_horizontal__jtHZg"};